// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text, Sprite, Graphics } from 'pixi.js';
import { ButtonLargeLayout } from '../../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: '7e9ddbe4-9e84-407e-99a3-b71507247faf',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '54cb2fe2-d9b3-4b9f-a424-cd21992fda1f',
      type: 'Container',
      name: 'loadingContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7e9ddbe4-9e84-407e-99a3-b71507247faf'
    },
    {
      id: '6ab3c29d-03d5-4e64-8983-140e01df7aca',
      type: 'Container',
      name: 'readyContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7e9ddbe4-9e84-407e-99a3-b71507247faf'
    },
    {
      id: '41b108c6-c500-4272-a9a3-ba90f9c3cd65',
      type: 'Text',
      name: 'offerName',
      className: '',
      x: -325,
      y: 97,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Bundle Name',
      localize: false,
      maxWidth: 370,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 46,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#8F2C2B',
        stroke: '#FFEC67',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 1,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '7e9ddbe4-9e84-407e-99a3-b71507247faf',
      stateByName: {
        basic_offer: {
          style: {
            fill: '#8F2C2B',
            stroke: '#FFEC67'
          }
        },
        special_offer: {
          style: {
            fill: '#FFFFFF',
            stroke: '#1B2C7D'
          }
        }
      }
    },
    {
      id: 'b5ecbd05-cb98-4534-ba87-a5d21b71381e',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0.5,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Yellow_Bundle_Background',
      parent: '54cb2fe2-d9b3-4b9f-a424-cd21992fda1f'
    },
    {
      id: 'ac853943-0c27-48bd-bedf-33ae3be18e7b',
      type: 'Container',
      name: 'spinnerSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '54cb2fe2-d9b3-4b9f-a424-cd21992fda1f'
    },
    {
      id: 'bbbb56bc-4bcc-4cd0-973b-e5d9b416b366',
      type: 'Sprite',
      name: 'background',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '6ab3c29d-03d5-4e64-8983-140e01df7aca'
    },
    {
      id: '048dd766-5629-4631-96e2-ccea76d6acfc',
      type: 'Graphics',
      name: 'bannerContainer',
      className: '',
      x: 199,
      y: -205,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6ab3c29d-03d5-4e64-8983-140e01df7aca',
      commands: []
    },
    {
      id: '90b82995-c162-417b-a9dc-92911ee595e7',
      type: 'Container',
      name: 'timerContainer',
      className: '',
      x: -246,
      y: -178,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6ab3c29d-03d5-4e64-8983-140e01df7aca'
    },
    {
      id: 'c914df28-d2e6-4c26-a92e-5bb5da2b0658',
      type: 'Container',
      name: 'buyButton',
      className: '',
      x: 220,
      y: 99,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6ab3c29d-03d5-4e64-8983-140e01df7aca'
    },
    {
      id: '1163e074-6b39-473e-8f56-f3df81dee0da',
      type: 'Sprite',
      name: 'banner',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Red_Banner',
      parent: '048dd766-5629-4631-96e2-ccea76d6acfc'
    },
    {
      id: '3535fc44-be13-4ddc-a7b9-1c955f5c1904',
      type: 'Text',
      name: 'bannerText',
      className: '',
      x: 119,
      y: 64,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 45,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'POPULAR',
      localize: true,
      maxWidth: 140,
      maxHeight: 60,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '048dd766-5629-4631-96e2-ccea76d6acfc'
    },
    {
      id: '78f1b1b2-8fd9-48d6-abe2-9fd7352ec70c',
      type: 'Sprite',
      name: 'timer',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Timer_Background',
      parent: '90b82995-c162-417b-a9dc-92911ee595e7'
    },
    {
      id: '5089e2b4-bf9d-449a-9ae7-326c1184aae3',
      type: 'Text',
      name: 'timerText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1d20h',
      localize: false,
      maxWidth: 150,
      maxHeight: 40,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 37,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 2,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '90b82995-c162-417b-a9dc-92911ee595e7'
    },
    {
      id: 'eebdc9aa-e1ec-4b68-b7d0-cc500f8ccffe',
      type: 'Sprite',
      name: '',
      className: '',
      x: -95,
      y: 1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Golden_Clock',
      parent: '90b82995-c162-417b-a9dc-92911ee595e7'
    },
    {
      id: 'ead52cb2-8193-4f19-ace0-a2d92a6aa61d',
      type: 'Layout',
      name: 'nineSliceButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 1,
      scale: {
        x: 0.77,
        y: 0.83
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'c914df28-d2e6-4c26-a92e-5bb5da2b0658',
      data: {
        color: 'green'
      }
    },
    {
      id: 'e24c3901-4ca6-4221-a071-65cab848aaac',
      type: 'Text',
      name: 'buttonLabel',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'GO!',
      localize: true,
      maxWidth: 176,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ffffff',
        stroke: '#01632D',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.3,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c914df28-d2e6-4c26-a92e-5bb5da2b0658'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  handleResize: false
} as const;

export class ShopSpecialOfferLayout {
  static raw = raw;
  root!: Container;
  loadingContainer!: Container;
  readyContainer!: Container;
  offerName!: Text;
  spinnerSlot!: Container;
  background!: Sprite;
  bannerContainer!: Graphics;
  timerContainer!: Container;
  buyButton!: Container;
  banner!: Sprite;
  bannerText!: Text;
  timer!: Sprite;
  timerText!: Text;
  nineSliceButton!: ButtonLargeLayout & { data: typeof raw['list'][15]['data'] };
  buttonLabel!: Text;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
